<template type="x/template">
  <transition name="modal" id="product-history-dialog">
    <DxPopup
      id="dx-dialog"
      width="100vw"
      height="100vh"
      :hide-on-outside-click="false"
      :show-close-button="true"
      :visible="showPopup"
      :resize-enabled="false"
      :drag-enabled="false"
      @hidden="$emit('hidden')"
      :wrapper-attr="popupAttributes"
    >
      <template #title>
        <div class="product-history-header">
          <div class="left_side" @click="buttonCloseEvent">
            <img src="@/assets/images/icons/arrow-back.svg" />
            <span>{{ $t("common.back") }}</span>
          </div>
          <div class="right_side">
            <img src="@/assets/images/icons/dialog-close.svg" @click="buttonCloseEvent" />
          </div>
        </div>
      </template>

      <template #content>
        <div class="product-history-container">
          <div class="title-container">
            <img class="title-image" src="@/assets/images/icons/droplet-simple-green.svg" />
            <div class="title-text">
              {{ templateData.product.code ? `${templateData.product.name} (${templateData.product.code})` : templateData.product.name }}
            </div>
            <div class="subtitle-text">
              <span>{{ productData.quantity | getLocalFormattedQuantity }} {{ productData.mu }}</span> {{ $t("stock_mobile.history.in_warehouse") }}
              <span>{{ productData.warehouse_name }}<template v-if="productData.department_name"> ({{ productData.department_name }})</template></span> {{ $t("stock_mobile.history.with_value") }} <span>{{ productData.total_price.toLocaleString() }}</span> RON
            </div>
            <button type="button" class="product-history-plus-button" aria-label="Consum rapid" @click="openConsum">
              <img src="@/assets/images/icons/plus.svg" alt="Consum rapid" />
            </button>
          </div>
          <div class="dialog_title_separator"></div>
          <DxScrollView
            ref="scrollView"
            class="product-history-scrollable-container"
            :element-attr="scrollAttributes"
            :use-native="true"
            :reach-bottom-enabled="pagination.has_more_pages"
            @reach-bottom="loadMoreHistory"
          >
            <div>
              <div class="movement-container" v-for="movement in historyData" :key="movement.uuid">
                <div class="movement-date-container">
                  <div :class="movementCancelClass(movement)" class="movement-date">{{ movementDate(movement) }}</div>
                  <div class="machine-date-line"></div>
                </div>
                <div class="movement-data">
                  <div class="movement-image">
                    <img
                      v-if="(movement.transaction_type_code || '').toLowerCase() == 'transfer'"
                      src="@/assets/images/icons/transfer.svg"
                    />
                    <img
                      v-if="(movement.transaction_type_code || '').toLowerCase() == 'reception'"
                      class="reception_image"
                      src="@/assets/images/icons/receptie.svg"
                    />
                  </div>
                  <div class="movement-type-price">
                    <div :class="movementCancelClass(movement)" class="movement-type">{{ transactionName(movement) }}</div>
                    <div :class="movementCancelClass(movement)" class="movement-product-price">{{ $t("stock_mobile.history.value_ron") }}: {{ movement.total }}</div>
                  </div>
                  <div class="movement-quantity">
                    <div :class="movementCancelClass(movement)" class="movement-quantity-label">{{ $t("common.quantity") }}</div>
                    <div :class="movementCancelClass(movement)" class="movement-quantity-value">
                      {{ movement.quantity | getLocalFormattedQuantity }} {{ productData.mu }}
                    </div>
                  </div>
                  <div class="movement-sold">
                    <div :class="movementCancelClass(movement)" class="movement-sold-label">{{ $t("stock_mobile.history.balance") }}</div>
                    <div :class="movementCancelClass(movement)" class="movement-sold-value">
                      {{ movement.new_quantity | getLocalFormattedQuantity }} {{ productData.mu }}
                    </div>
                  </div>
                </div>
                <div v-if="movement.shipping_note_number" :class="movementCancelClass(movement)" class="movement-notes">
                  {{ $t("stock_mobile.history.shipping_note") }}: {{ movement.shipping_note_number }}
                </div>
                <div v-if="movement.notes" :class="movementCancelClass(movement)" class="movement-notes">
                  {{ movement.notes }}
                </div>
                <div v-if="!!movement?.workGeneratorData?.work_name" class="movement-work">
                  {{ $t("stock_mobile.history.work") }}: <span style="font-weight: 400">{{ movement.workGeneratorData.work_name }}</span> {{ $t("stock_mobile.history.tractor") }}:
                  <span style="font-weight: 400">{{ movement.workGeneratorData.work_machine_name }}</span> {{ $t("stock_mobile.history.parcel") }}:
                  <span style="font-weight: 400">{{ movement.workGeneratorData.parcel_name }}</span>
                </div>
                <div
                  v-if="!movement?.workGeneratorData?.work_name && !!movement?.workGeneratorData?.work_machine_name"
                  class="movement-work"
                >
                  {{ $t("stock_mobile.history.machinery") }}: <span style="font-weight: 400">{{ movement.workGeneratorData.work_machine_name }}</span>
                </div>
                <div
                  v-if="movement.download_url"
                  :class="movementCancelClass(movement)"
                  class="movement-document"
                  @click="documentClick(movement, false)"
                >
                  {{ $t("stock_mobile.history.download") }} {{ $t("stock_mobile.history.document") }}
                </div>
                <div v-else>
                  <div
                    v-if="hasDocumentGeneratorRole() && movement.canceled_quantity == 0"
                    :class="movementCancelClass(movement)"
                    class="movement-document"
                    @click="documentClick(movement, false)"
                  >
                    {{ $t("stock_mobile.history.generate") }} {{ $t("stock_mobile.history.document") }}
                  </div>
                </div>
                <div
                  v-if="movement.delivery_note_download_url"
                  :class="movementCancelClass(movement)"
                  class="movement-document"
                  @click="deliveryNoteClick(movement)"
                >
                  {{ $t("stock_mobile.history.download") }} {{ $t("stock_mobile.history.delivery_note_document") }}
                </div>
                <div
                  v-if="movement.cancel_download_url"
                  :class="movementCancelClass(movement)"
                  class="movement-document"
                  @click="documentClick(movement, true)"
                >
                  {{ $t("stock_mobile.history.download") }} {{ $t("stock_mobile.history.cancel_document") }}
                </div>
                <div v-else>
                  <div
                    v-if="hasDocumentGeneratorRole() && movement.canceled_quantity > 0 && movement.document_uuid"
                    :class="movementCancelClass(movement)"
                    class="movement-document"
                    @click="documentClick(movement, true)"
                  >
                    {{ $t("stock_mobile.history.generate") }} {{ $t("stock_mobile.history.cancel_document") }}
                  </div>
                </div>
              </div>
              <div class="movement_history_bottom_spacer"></div>
            </div>
          </DxScrollView>
          <toast-message ref="toastMessage"></toast-message>
        </div>
      </template>
    </DxPopup>
  </transition>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { mapGetters, mapActions } from "vuex";
import ToastMessage from "../../../components/Mobile/toastMessage.vue";
import { permissions, hasRole } from "@/helpers/Permissions";
import moment from "moment";

export default {
  name: "ProductHistory",
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
    templateData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      popupAttributes: {
        class: "product_history_dialog_wrapper",
      },
      historyData: [],
      historyLoading: false,
      historyLoadingMore: false,
      pagination: {
        current_page: 1,
        last_page: 1,
        has_more_pages: false,
        next_page: null,
      },
      productData: {
        quantity: 0.0,
        warehouse_name: "",
        department_name: "",
        total_price: "",
        mu: "",
      },
    };
  },
  components: {
    DxPopup,
    DxScrollView,
    ToastMessage,
  },
  watch: {
    showPopup(newVal) {
      if (newVal) {
        this.resetHistoryState();
        this.fetchHistoryPage(true);
        this.getProductHistory({
          product_uuid: this.templateData.product.uuid,
          warehouse_uuid: this.templateData.warehouse.warehouse_uuid,
          //department_uuid: this.currentDepartment.department_uuid,
        }).then((response) => {
          this.productData.quantity = response[0].products[0].total_quantity;
          this.productData.warehouse_name = response[0].name;
          this.productData.department_name = response[0].department_name || "";
          this.productData.total_price = response[0].products[0].total_price;
          this.productData.mu = response[0].products[0].measure_unit_name;
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      currentDepartment: "auth/currentDepartment",
      getDefaultDateFormat: "settings/getDefaultDateFormat",
    }),
    scrollAttributes() {
      const noMorePages = !this.pagination?.has_more_pages;
      return {
        class: noMorePages ? "product-history-scroll no-more-pages" : "product-history-scroll",
      };
    },
    movementCancelClass() {
      return (movement) => {
        return {
          canceled: movement.canceled_quantity > 0,
        };
      };
    },
  },
  methods: {
    ...mapActions({
      getProductHistory: "smStocks/getSmStockProductHistory",
      getData: "smTransactions/getSmStockMovements",
      getProduct: "smProducts/getSmProduct",
      getExportInfo: "smTransactions/getExportInfo",
      getDownloadInfo: "smTransactions/getDownloadInfo",
      downloadPdf: "smTransactions/downloadPdf",
    }),
    movementDate(movement) {
      return moment(movement.movement_date)?.format(this.getDefaultDateFormat) ?? movement.movement_date;
    },
    resetHistoryState() {
      this.historyData = [];
      this.pagination = {
        current_page: 1,
        last_page: 1,
        has_more_pages: false,
        next_page: null,
      };
      this.historyLoading = false;
      this.historyLoadingMore = false;
    },
    loadMoreHistory() {
      if (this.historyLoading || this.historyLoadingMore) {
        return;
      }
      if (!this.pagination?.has_more_pages) {
        return;
      }
      this.fetchHistoryPage(false);
    },
    async fetchHistoryPage(reset) {
      if (!this.templateData?.product?.uuid || !this.templateData?.warehouse?.warehouse_uuid) {
        return;
      }

      if (reset) {
        this.historyLoading = true;
      } else {
        this.historyLoadingMore = true;
      }

      const limit = 20;
      const page = reset ? 1 : this.pagination?.next_page || this.pagination?.current_page + 1;
      try {
        const response = await this.getData({
          product_uuid: this.templateData.product.uuid,
          warehouse_uuid: this.templateData.warehouse.warehouse_uuid,
          //department_uuid: this.currentDepartment.department_uuid,
          page,
          limit,
        });

        const rows = response?.data || [];
        this.historyData = reset ? rows : [...this.historyData, ...rows];

        const pagination = response?.pagination || {};
        const currentPage = pagination.current_page ?? page;
        const lastPage = pagination.last_page ?? pagination.current_page ?? page;
        const nextPage = pagination.next_page ?? null;
        let hasMorePages = pagination.has_more_pages;

        if (hasMorePages === undefined || hasMorePages === null) {
          if (nextPage !== null && nextPage !== undefined) {
            hasMorePages = !!nextPage;
          } else if (lastPage !== null && lastPage !== undefined) {
            hasMorePages = currentPage < lastPage;
          } else {
            hasMorePages = rows.length === limit;
          }
        }

        if (rows.length < limit) {
          hasMorePages = false;
        }

        this.pagination = {
          current_page: currentPage,
          last_page: lastPage,
          has_more_pages: !!hasMorePages,
          next_page: nextPage,
        };
      } finally {
        this.historyLoading = false;
        this.historyLoadingMore = false;
        if (this.$refs.scrollView?.instance) {
          const shouldReleaseFinal = !this.pagination?.has_more_pages || this.historyData.length === 0;
          this.$refs.scrollView.instance.release(shouldReleaseFinal);
          this.$refs.scrollView.instance.update();
          if (reset) {
            this.$refs.scrollView.instance.scrollTo(0);
          }
        }
      }
    },
    hasDocumentGeneratorRole() {
      return hasRole(this, permissions.STOCK_DOCUMENT_CREATOR);
    },
    buttonCloseEvent() {
      this.$emit("hidden");
    },
    openConsum() {
      this.$emit("openConsum", this.templateData);
    },
    transactionName(movement) {
      const transactionType = (movement.transaction_type_code || "").toLowerCase();
      if (transactionType == "reception") {
        return this.$t("stock_mobile.transactions.reception");
      }
      if (transactionType == "transfer") {
        if ((movement.type = "REMOVE")) {
          if (movement.old_quantity > movement.new_quantity) {
            return this.$t("stock_mobile.history.transfer_to", { name: movement.dest_warehouse.name });
          } else {
            return this.$t("stock_mobile.history.transfer_from", { name: movement.dest_warehouse.name });
          }
        }
        return this.$t("stock_mobile.transactions.transfer");
      }
      if (transactionType == "consum") {
        return this.$t("stock_mobile.transactions.consum");
      }
      if (transactionType == "initial_import") {
        return this.$t("stock_mobile.history.initial_stock");
      }
      if (transactionType == "sales") {
        return this.$t("stock_mobile.transactions.sales");
      }
      if (transactionType == "requalification") {
        return this.$t("stock_mobile.transactions.reclassification");
      }
      return movement.transaction_type;
    },
    downloadDocument(movement, is_cancel) {
      this.getDownloadInfo({
        type: movement.transaction_type_code,
        url: is_cancel ? movement.cancel_export_url : movement.export_url,
      })
        .then((resp) => {
          this.downloadPdf({
            type: is_cancel ? movement.cancel_document_uuid : movement.document_uuid,
            url: is_cancel ? movement.cancel_download_url : movement.download_url,
            filename: resp.data.download_filename,
            response_type: "blob",
          }).catch((e) => {
            console.log("preview download error: ", e.response);
            if (e.response.status === 400 || e.response.status === 500) {
              if (e.response.data.errors && e.response.data.errors.error) {
                this.$refs.toastMessage.showError(this.$t("stock_mobile.history.error_document_download") + " " + e.response.data.errors.error);
              } else {
                this.$refs.toastMessage.showError(this.$t("stock_mobile.history.error_document_download"));
              }
            }
          });
        })
        .catch((e) => {
          console.log("check download error: ", e.response);
          if (e.response.status === 400 || e.response.status === 500) {
            if (e.response.data.errors && e.response.data.errors.error) {
              this.$refs.toastMessage.showError(this.$t("stock_mobile.history.error_document_download") + " " + e.response.data.errors.error);
            } else {
              this.$refs.toastMessage.showError(this.$t("stock_mobile.history.error_document_download"));
            }
          }
        });
    },
    deliveryNoteClick(movement) {
      this.downloadPdf({
        type: movement.delivery_note_document_uuid,
        url: movement.delivery_note_download_url,
        filename: movement.delivery_note_download_filename,
        response_type: "blob",
      }).catch((e) => {
        console.log("delivery note download error: ", e.response);
        if (e.response && (e.response.status === 400 || e.response.status === 500)) {
          if (e.response.data.errors && e.response.data.errors.error) {
            this.$refs.toastMessage.showError(this.$t("stock_mobile.history.error_document_download") + " " + e.response.data.errors.error);
          } else {
            this.$refs.toastMessage.showError(this.$t("stock_mobile.history.error_document_download"));
          }
        }
      });
    },
    documentClick(movement, is_cancel) {
      if (
        (!is_cancel && movement.download_url && movement.download_url.length > 0) ||
        (is_cancel && movement.cancel_download_url && movement.cancel_download_url.length > 0)
      ) {
        this.downloadDocument(movement, is_cancel);
      } else {
        this.getExportInfo({
          type: movement.transaction_type_code,
          url: is_cancel ? movement.cancel_export_url : movement.export_url,
          response_type: "application/json",
        })
          .then((resp) => {
            this.updateBatchTransactionExports(resp.data.transaction);
            this.downloadPdf({
              type: movement.transaction_type_code,
              url: is_cancel ? resp.data.cancel_download_url : resp.data.download_url,
              filename: resp.data.download_filename,
              response_type: "blob",
            });
          })
          .catch((error) => {
            console.log("documentClick export error", error);
            let msg = "";

            if (error.response.data && error.response.data.errors && error.response.data.errors.error) {
              msg =
                error.response.data.errors.error && error.response.data.errors.error.length > 0 ? error.response.data.errors.error[0] : "";
            }

            this.$refs.toastMessage.showError(this.$t("stock_mobile.history.error_document_download") + msg);
            console.log(this.$t("stock_mobile.history.error_document_download"), error);
          });
      }
    },
    updateBatchTransactionExports(transaction) {
      let vm = this;
      if (transaction.batch_uuid) {
        let batchTransactions = vm.historyData.filter((t) => t.batch_uuid === transaction.batch_uuid);

        if (batchTransactions) {
          batchTransactions.forEach((item) => {
            let updated = item;
            updated.canceled_doc_header_uuid = transaction.canceled_doc_header_uuid;
            updated.document = transaction.document;
            updated.document_block = transaction.document_block;
            updated.document_block_uuid = transaction.document_block_uuid;
            updated.document_id = transaction.document_id;
            updated.download_filename = transaction.download_filename;
            updated.download_url = transaction.download_url;
            updated.export_url = transaction.export_url;

            vm.historyData.splice(vm.historyData.indexOf(vm.historyData.find((it) => it.uuid === item.uuid)), updated);
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/productHistory.scss";

.product-history-container .title-container {
  position: relative;
}

.product-history-container .product-history-plus-button {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  border-radius: 9999px;
  border: none !important;
  outline: none;
  background: #0a8f3c !important;
  color: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
}

.product-history-container .product-history-plus-button img {
  display: block;
  width: 16px;
  height: 16px;
}
</style>
